<div class="container">

  <div class="p-2">
    <h2>Filter Properties</h2>
  </div>

  <div class="card">
    <form [formGroup]="filterForm" (ngSubmit)="generateSubset()">
      <div class="flex flex-row bg-yellow-100 pt-3 pb-5 pl-2 gap-2 mb-2">
        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-palette"></i>
            Segment
          </div>
          <p-multiselect
            formControlName="segments"
            [options]="segmentsOptions"
            id="segments"
            placeholder="Select segment">
          </p-multiselect>
        </div>

        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-star"></i>
            Rate
          </div>
          <p-multiselect
            formControlName="stars"
            [options]="starsOptions"
            id="stars"
            placeholder="Select rate">
          </p-multiselect>
        </div>

        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-tag"></i>
            Brand
          </div>
          <p-multiselect
            formControlName="brand"
            [options]="brandsOptions"
            id="brand"
            placeholder="Select brand">
          </p-multiselect>
        </div>

        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-directions"></i>
            Destinations
          </div>
          <p-multiselect
            [filter]="false"
            formControlName="destinations"
            [options]="destinationsOptions"
            id="destinations"
            placeholder="Select destinations">
          </p-multiselect>
        </div>

        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-gift"></i>
            Special Offers
          </div>
          <p-multiselect
            [filter]="false"
            formControlName="specialOffers"
            [options]="specialOfferOptions"
            id="specialOffers"
            placeholder="Select Special Offers">
          </p-multiselect>
        </div>

        <div class="filter-col">
          <div class="filter-label">
            <i class="pi pi-check-circle"></i>
            Activity
          </div>
          <p-multiselect
            [filter]="false"
            formControlName="activities"
            [options]="activityOptions"
            id="activity"
            placeholder="Select activity">
          </p-multiselect>
        </div>

      </div>
      <div class="flex items-center gap-3 border-bottom-1 border-gray-200 pl-2 pr-2 pb-2">
        <button type="submit" pButton class="btn btn-primary">
          Get properties
        </button>
        <button *ngIf="filteredProperties.length !== 0" pButton class="btn btn-secondary" type="button"
                (click)="generateRecommendation()">
          Generate recommendation
        </button>
      </div>
    </form>

    <div *ngIf="filteredProperties.length !== 0" id="selectedLanguages" class="m-2 bg-gray-200">
      <label
        *ngFor="let lang of languageKeys()"
        class="mr-4 cursor-pointer inline-flex items-center"
      >
        <input
          type="checkbox"
          class="mr-1"
          [checked]="selectedLanguages[lang]"
          (change)="onLanguageToggle(lang, $event)"
        />
        {{ lang.toUpperCase() }}
      </label>
    </div>
    <!--  filtered prop table -->
    <div *ngIf="filteredProperties?.length !==0 && recommendedProperties.length === 0" class="table-scroll-x w-full">
      <div class="p-2 bg-gray-200">
        <h4>Properties :</h4>
      </div>
      <p-table class="min-w-full" [columns]="filteredTableCols"
               [value]="filteredProperties" [scrollable]="true"
               [scrollHeight]="'500px'">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="border border-gray-300 bg-blue-100 text-xs"></th>
            <th class="border border-gray-300 bg-blue-100 px-3 py-2 text-xs">#</th>
            <th *ngFor="let col of columns" class="border border-gray-300 bg-blue-100 px-3 py-2 text-xs">

              <ng-container [ngSwitch]="col">

                <span *ngSwitchCase="'destination.name'" class="inline-flex gap-x-2">
                  Destination
                </span>

                <span *ngSwitchCase="'destination.sector'" class="inline-flex gap-x-2">
                  Sector
                </span>

                <!-- DEFAULT PRIKAZ -->
                <span *ngSwitchDefault>
              {{ Helper.convertToStandard(col) }}
                </span>
              </ng-container>
            </th>
            <th class="border border-gray-300 bg-blue-100 text-xs">Edit</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [ngClass]="{'invalid-property-row': isInvalidProperty(rowData)}" [pTooltip]="isInvalidProperty(rowData) ? 'Nedostaje naziv destinacije - uredi property prije slanja na recommendation' : ''" tooltipPosition="top">
            <td class="border border-gray-300 text-center bg-gray-50 text-xs">

              <div
                pButton
                type="button"
                icon="pi pi-trash"
                (click)="removeProperty(rowData)"
                (keydown.enter)="removeProperty(rowData)"
                (keydown.space)="removeProperty(rowData)"
                role="button"
                tabindex="0"
                class="p-0 p-button-rounded p-button-text"
              ></div>

            </td>
            <td class="border border-gray-300 px-3 py-2 text-center font-bold bg-gray-50 text-xs">{{ rowIndex + 1 }}
            </td>
            <td *ngFor="let col of columns" class="border border-gray-300 px-3 py-2 text-xs">

              <ng-container [ngSwitch]="col">
                <!-- URL PRIKAZ -->
                <span *ngSwitchCase="'url'" class="inline-flex gap-x-2">
                      <a [href]="rowData[col] || '#'"
                         class="text-blue-600 hover:underline"
                         target="_blank" rel="noopener"
                      >
                        {{ rowData[col] }}
                      </a>
                </span>

                <span *ngSwitchCase="'destination.name'" class="inline-flex gap-x-2">
                      {{ rowData['destination']?.name }}
                </span>

                <span *ngSwitchCase="'name'" class="inline-flex gap-x-2">
                      <a class="cursor-pointer"
                         (click)="editProperty(rowData)"
                         role="button"
                         tabindex="0"
                         (keydown.enter)="editProperty(rowData)"
                         (keydown.space)="editProperty(rowData)">
                        {{ rowData[col] }}
                      </a>
                </span>

                <span *ngSwitchCase="'destination.sector'" class="inline-flex gap-x-2">
                      {{ rowData['destination']?.sector }}
                </span>

                <span *ngSwitchCase="'specialOffers'" class="inline-flex gap-x-2">
                        <ng-container *ngIf="rowData[col]?.length > 0; else specialOffersEmpty">
                          <ng-container *ngFor="let offer of rowData[col]; let i = index">
                            <span> <a href="{{offer.url}}" target="_blank">{{ offer.caption }}</a></span>
                            <span *ngIf="i < rowData[col].length - 1" class="text-gray-400 p-1"> , </span>
                          </ng-container>
                        </ng-container>
                        <ng-template #specialOffersEmpty>
                          <span class="text-gray-400 italic">N/A</span>
                        </ng-template>
                </span>

                <span *ngSwitchCase="'specialOffersMinPrice'" class="inline-flex gap-x-2">
                      {{ getSpecialOffersMinPrice(rowData['specialOffers']) }}
                </span>

                <span *ngSwitchCase="'minPrice'" class="inline-flex gap-x-2">
                      {{ formatPrice(rowData[col]) }}
                </span>

                <!-- DEFAULT PRIKAZ -->
                <span *ngSwitchDefault>
                    {{ rowData[col] }}
                </span>
              </ng-container>
            </td>
            <td class="border border-gray-300 px-3 py-2 text-xs">
              <div
                pButton
                pRipple
                type="button"
                icon="pi pi-file-edit"
                (click)="editProperty(rowData)"
                (keydown.enter)="editProperty(rowData)"
                (keydown.space)="editProperty(rowData)"
                role="button"
                tabindex="0"
                class="p-0 p-button-rounded p-button-text"
              ></div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="recommendedProperties?.length !==0" class="table-scroll-x">
      <div class="p-2 bg-green-200">
        <div class="d-flex justify-content-between">
          <h4>
            Recommendations :
          </h4>
          <button pButton pRipple type="button"
                  class="btn btn-success flex items-center ml-auto"
                  (click)="exportExcel()">
            <i class="pi pi-file-excel mt-1 mr-1"></i> Export to excel
          </button>
        </div>

      </div>

      <p-table class="min-w-full" [columns]="recommendedTableCols"
               [value]="recommendedProperties" [scrollable]="true"
               [scrollHeight]="'500px'">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="border border-gray-500 bg-blue-100 px-3 py-2 text-xs">#</th>
            <th *ngFor="let col of columns" class="border border-gray-500 bg-blue-100 px-3 py-2 text-xs">
              {{ Helper.convertToStandard(col) }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td class="border border-gray-300 px-3 py-2 text-center font-bold bg-gray-50 text-xs">{{ rowIndex + 1 }}
            </td>
            <td *ngFor="let col of columns" class="border border-gray-300 px-3 py-2 text-xs">

              <ng-container [ngSwitch]="col">
                <!-- URL PRIKAZ -->
                <span *ngSwitchCase="'url'" class="inline-flex gap-x-2">
                      <a [href]="rowData[col] || '#'"
                         class="text-blue-600 hover:underline"
                         target="_blank" rel="noopener"
                      >
                        {{ rowData[col] }}
                      </a>
                </span>

                <span *ngSwitchCase="'specialOffers'" class="inline-flex gap-x-2">
                        <ng-container *ngIf="rowData[col]?.length > 0; else specialOffersEmpty">
                          <ng-container *ngFor="let offer of rowData[col]; let i = index">
                            <span> <a href="{{offer.url}}" target="_blank">{{ offer.caption }}</a></span>
                            <span *ngIf="i < rowData[col].length - 1" class="text-gray-400 p-1"> , </span>
                          </ng-container>
                        </ng-container>
                        <ng-template #specialOffersEmpty>
                          <span class="text-gray-400 italic">N/A</span>
                        </ng-template>
                </span>

                <span *ngSwitchCase="'specialOffersMinPrice'" class="inline-flex gap-x-2">
                      {{ getSpecialOffersMinPrice(rowData['specialOffers']) }}
                </span>

                <span *ngSwitchCase="'minPrice'" class="inline-flex gap-x-2">
                      {{ formatPrice(rowData[col]) }}
                </span>

                <!--                switch recc1 to be editable-->

                <!--                <span *ngSwitchCase="'recommended1'" class="inline-flex gap-x-2">-->
                <!--                      <input type="text" pInputText value="{{ rowData[col] }}"/>-->
                <!--                </span>-->

                <span *ngSwitchCase="'recommended1'" class="inline-flex gap-x-2">
                    <input type="text"
                           class="border rounded border-gray-200 p-2"
                           [(ngModel)]="rowData[col]"
                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>
                </span>

                <span *ngSwitchCase="'recommended2'" class="inline-flex gap-x-2">
                    <input type="text"
                           class="border rounded border-gray-200 p-2"
                           [(ngModel)]="rowData[col]"
                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>
                </span>

                <span *ngSwitchCase="'recommended3'" class="inline-flex gap-x-2">
                    <input type="text"
                           class="border rounded border-gray-200 p-2"
                           [(ngModel)]="rowData[col]"
                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>
                </span>

                <span *ngSwitchCase="'destination'" class="inline-flex gap-x-2">
                      {{ rowData['destination']?.name }}
                </span>

                <!--                switch recc1 to be editable-->

                <!--                <span *ngSwitchCase="'recommended1'" class="inline-flex gap-x-2">-->
                <!--                      <input type="text" pInputText value="{{ rowData[col] }}"/>-->
                <!--                </span>-->

                <!--                <span *ngSwitchCase="'recommended1'" class="inline-flex gap-x-2">-->
                <!--                    <input type="text"-->
                <!--                           pInputText-->
                <!--                           [(ngModel)]="rowData[col]"-->
                <!--                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>-->
                <!--                </span>-->

                <!--                <span *ngSwitchCase="'recommended2'" class="inline-flex gap-x-2">-->
                <!--                    <input type="text"-->
                <!--                           pInputText-->
                <!--                           [(ngModel)]="rowData[col]"-->
                <!--                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>-->
                <!--                </span>-->

                <!--                <span *ngSwitchCase="'recommended3'" class="inline-flex gap-x-2">-->
                <!--                    <input type="text"-->
                <!--                           pInputText-->
                <!--                           [(ngModel)]="rowData[col]"-->
                <!--                           (ngModelChange)="onRecommendedInputChange(rowIndex , col, $event)"/>-->
                <!--                </span>-->

                <!-- DEFAULT PRIKAZ -->
                <span *ngSwitchDefault>
                    {{ rowData[col] }}
                </span>
              </ng-container>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <p-dialog
    [(visible)]="loading"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [baseZIndex]="4"
    showHeader="false"
    styleClass="spinner-dialog"
  >
    <div class="spinner-content">
      <p-progress-spinner></p-progress-spinner>
      <div class="spinner-label"></div>
    </div>
  </p-dialog>
</div>

